module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('h1', {
    staticClass: "h1"
  }, [_c('span', {
    attrs: {
      "aria-label": "v",
      "epub:type": "pagebreak",
      "id": "page_v",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("CONTENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/foreword#foreword"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/preface#preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/intro#intro"
    }
  }, [_vm._v("Introduction: Defining the Inclusive Leader")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/core#core"
    }
  }, [_vm._v("The Core of Inclusive Leadership: The Enabling Traits")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpart"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part1#part1"
    }
  }, [_vm._v("PART 1. THE FIVE DISCIPLINES")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch01#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Discipline 1: Builds Interpersonal Trust")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch02#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Discipline 2: Integrates Diverse Perspectives")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Discipline 3: Optimizes Talent")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Discipline 4: Applies an Adaptive Mindset")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Discipline 5: Achieves Transformation")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpart"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2#part2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART 2. THE EXEMPLARS")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Barilla: Preserving Tradition While Changing It")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. John Deere: Inclusive Leadership Feeds the World")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch08#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Marriott: Where Everyone Belongs")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch09#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Ravinia Festival: Setting the Stage from the Stage")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpart"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part3#part3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART 3. TACKLING THE MEGA DIVERSITY AND INCLUSION CHALLENGES")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Structural Inclusion: Confronting the Reference Man Norms That Leave Most of Us Out")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Identity Inclusion: The Perennial Unfinished Business of Race and Gender")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. Sociopolitical Inclusion: When the Outside Comes Inside")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/conclusion#con",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion. Creating Inclusive Organizations—Who Has the Last Word?")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbma"
  }, [_c('span', {
    attrs: {
      "aria-label": "vi",
      "epub:type": "pagebreak",
      "id": "page_vi",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/appa#appa",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix A. Bonus Tracks: Spotlight on the Enabling Traits and Structural Inclusion")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocbma"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/appb#appb",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix B. Research Methods behind Korn Ferry’s Inclusive Leader Model")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbma"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/appc#appc",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix C. Resources")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/gloss#gloss",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glossary")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bib#bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ack#ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index#index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/about#about",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Authors")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/about1#about1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About Korn Ferry")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 66
// module chunks = 0